import { services } from "@/mocks/services";
import { buildWhatsAppLink } from "@/utils/whatsapp";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

export default function Services() {
  return (
    <section id="hizmetler" className="ivory-canvas bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Hizmetlerimiz"
            title="Tek Çatı Altında Bakım Seçenekleri"
            description="Farklı bakım ihtiyaçlarınıza yönelik uygulamaları kategorilere ayırdık. Detaylı bilgi için ilgili hizmetin butonundan bize yazabilirsiniz."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, index) => (
            <Reveal key={service.id} delay={(index % 4) * 80} className="h-full">
              <article className="flex h-full flex-col rounded-xl border border-background-300/70 bg-background-50 p-6 transition-colors duration-300 hover:border-accent-400">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-accent-400/60 bg-primary-50">
                  <i className={`${service.icon} text-2xl text-primary-600`} aria-hidden="true" />
                </span>

                <h3 className="mt-5 font-heading text-lg font-semibold tracking-tight text-foreground-950">
                  {service.title}
                </h3>

                <p className="mt-3 flex-1 font-body text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {service.description}
                </p>

                <a
                  href={buildWhatsAppLink(service.message)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-4 py-3 font-label text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-primary-700 transition-colors hover:bg-primary-600 hover:text-background-50 md:text-xs"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                  </span>
                  Detaylı Bilgi Al
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}